import { ClipboardPaste, Highlighter, Repeat } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Bring your text",
    icon: ClipboardPaste,
    body: "Paste a chapter, drop an .srt file, dump song lyrics, or import an article. Verbatim works with whatever you actually want to read — no curated library to outgrow.",
    chip: ".txt · .srt · .epub · paste",
  },
  {
    n: "02",
    title: "Read in colour",
    icon: Highlighter,
    body: "Words you already know turn green. New words show up red. The three most common new words in any text are flagged amber — learn those first and the rest unlocks.",
    chip: "known · new · priority · ignored",
  },
  {
    n: "03",
    title: "Carry the words with you",
    icon: Repeat,
    body: "Your vocabulary is per-language, not per-text. Mark a word as known in Harry Potter and it's known when you read the news tomorrow. Track every language in parallel.",
    chip: "cross-text · cross-source",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how" data-testid="how-section" className="relative py-24 sm:py-28">
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14 reveal">
          <div>
            <div className="mono-label mb-3">[ 01 · The loop ]</div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.02]">
              Paste. Read. Remember.
              <br />
              <span className="text-[var(--vb-muted)] font-light italic">
                The whole app, in three motions.
              </span>
            </h2>
          </div>
          <p className="max-w-md text-[var(--vb-muted)] text-base">
            No flashcards before bed. No games. No annoying owl. No streaks to break. No mails, no push notifications. 
            Just whatever you were going to read tonight. 
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`step-${i}`}
              className="card-soft p-7 lg:p-8 flex flex-col reveal"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex items-start justify-between mb-10">
                <span className="font-mono text-xs text-[var(--vb-primary)] tracking-[0.2em]">
                  / {s.n}
                </span>
                <div className="w-9 h-9 rounded-lg bg-[var(--vb-primary-soft)] border border-[rgba(95,168,255,0.3)] flex items-center justify-center">
                  <s.icon size={16} className="text-[var(--vb-primary)]" />
                </div>
              </div>
              <h3 className="font-display font-bold text-2xl lg:text-[1.6rem] tracking-tight mb-3">
                {s.title}
              </h3>
              <p className="text-[var(--vb-muted)] text-[15px] leading-relaxed flex-1">
                {s.body}
              </p>
              <div className="mono-label mt-6 pt-4 border-t border-[var(--vb-border)]">
                {s.chip}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
